import {inject} from '@angular/core';
import {CanActivateFn, GuardResult, Router, UrlTree} from '@angular/router';
import {LocalAuthService, UserService} from '@sso/ld-sso-with-oauth2-oidc';
import {filter, map, switchMap, take} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {hasRmDemoRole, Role} from '../../core/enums/role.enum';
import {RouteConstants} from '../constants/route-constants';

export const defaultRedirectGuard: CanActivateFn = (): Observable<GuardResult> => {
  const router = inject(Router);
  const localAuthService = inject(LocalAuthService);
  const userService = inject(UserService<Role>);

  return localAuthService.isDoneLoading$.pipe(
    filter(Boolean),
    take(1),
    switchMap(() => {
      if (!localAuthService.hasValidToken()) {
        localAuthService.login(RouteConstants.routeHome);
        return of(false);
      }

      return userService.getUserInfo$().pipe(
        take(1),
        map((user) => {
          const roles = user.info?.roles ?? [];

          if (hasRmDemoRole(roles)) {
            return router.createUrlTree([RouteConstants.routeDemo]);
          }

          return router.createUrlTree([RouteConstants.routeDashboard]);
        })
      );
    })
  );
};
